module.exports = __webpack_public_path__ + "fonts/2a09b4f57bc4094821b2bcad59cd112c-Roboto-BlackItalic.ttf";